import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UploadButton } from "@/components/UploadButton";
import { toast } from "sonner";

export default function AdminAirlines() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    name: "",
    code: "",
    country: "",
    logo: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/airlines");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data airline");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveAirline = async () => {
  try {

    if (editingId) {

      await api.patch(
        `/admin/master/airlines/${editingId}`,
        form
      );

      toast.success("Airline berhasil diperbarui");

    } else {

      await api.post(
        "/admin/master/airlines",
        form
      );

      toast.success("Airline berhasil ditambahkan");
    }

    setForm({
      name: "",
      code: "",
      country: "",
      logo: "",
    });

    setEditingId(null);

    loadData();

  } catch {
    toast.error("Gagal menyimpan airline");
  }
};

  const deleteAirline = async (id) => {
    if (!window.confirm("Hapus airline ini?")) return;

    try {
      await api.delete(`/admin/master/airlines/${id}`);
      toast.success("Airline berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus airline");
    }
  };

const editAirline = (item) => {

  setEditingId(item.id);

  setForm({
    name: item.name || "",
    code: item.code || "",
    country: item.country || "",
    logo: item.logo || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">
          Database Airlines
        </h1>
      </div>

      <div className="grid md:grid-cols-3 gap-3">
        <input
          className="border rounded px-3 py-2"
          placeholder="Airline Name"
          value={form.name}
          onChange={(e) =>
            setForm({
              ...form,
              name: e.target.value,
            })
          }
        />

        <input
          className="border rounded px-3 py-2"
          placeholder="Code (QR)"
          value={form.code}
          onChange={(e) =>
            setForm({
              ...form,
              code: e.target.value,
            })
          }
        />

        <input
          className="border rounded px-3 py-2"
          placeholder="Country"
          value={form.country}
          onChange={(e) =>
            setForm({
              ...form,
              country: e.target.value,
            })
          }
        />
      </div>

      <div className="space-y-2">
        <UploadButton
          label="Upload Airline Logo"
          onUploaded={(url) =>
            setForm({
              ...form,
              logo: url,
            })
          }
        />

        {form.logo && (
          <img
            src={form.logo}
            alt="Logo Preview"
            className="h-24 object-contain border rounded p-2"
          />
        )}
      </div>

<button
  onClick={saveAirline}
  className="bg-blue-600 text-white px-4 py-2 rounded"
>
  {editingId
    ? "Update Airline"
    : "Tambah Airline"}
</button>

{editingId && (
  <button
    onClick={() => {

      setEditingId(null);

      setForm({
        name: "",
        code: "",
        country: "",
        logo: "",
      });

    }}
    className="ml-3 border px-4 py-2 rounded"
  >
    Batal
  </button>
)}

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Logo</th>
            <th className="border p-2">Name</th>
            <th className="border p-2">Code</th>
            <th className="border p-2">Country</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">
                {item.logo && (
                  <img
                    src={item.logo}
                    alt={item.name}
                    className="h-10 object-contain"
                  />
                )}
              </td>

              <td className="border p-2">{item.name}</td>
              <td className="border p-2">{item.code}</td>
              <td className="border p-2">{item.country}</td>
<td className="border p-2 space-x-3">

  <button
    onClick={() => editAirline(item)}
    className="text-blue-600 font-medium"
  >
    Edit
  </button>

  <button
    onClick={() => deleteAirline(item.id)}
    className="text-red-600 font-medium"
  >
    Hapus
  </button>

</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
